import { FunctionComponent } from 'react'

type GameAdBoxProps = {
	//
}

const GameAdBox: FunctionComponent<GameAdBoxProps> = () => <div className="ad game-adbox" />

export default GameAdBox
